import React from "react";
import cn from "classnames";
import {createUseStyles} from "react-jss";
import {h1FontSize, largeFontSize, primaryTextColor, secondaryTextColor} from "~/theme";
import {UILineSkeleton} from "~/old-ui/UISkeleton";

export default function EntityTitle({loading, title, subtitle, className, ...props}) {
  const classes = useStyles();

  return (
    <div className={cn(classes.root, className)} {...props}>
      <h1 className={classes.h1}>{loading ? (<UILineSkeleton width={320}/>) : title}</h1>
      <div className={classes.subtitle}>{loading ? (<UILineSkeleton width={200}/>) : subtitle}</div>
    </div>
  )
}

const useStyles = createUseStyles({
  root: {
    margin: [[0, 0, 20]],
  },

  h1: {
    fontSize: h1FontSize,
    color: primaryTextColor,
    fontWeight: 500,
    margin: 0,
    padding: 0,
    marginBottom: 4,
  },

  subtitle: {
    color: secondaryTextColor,
    fontSize: largeFontSize,
  },
});
